const finnishPhonePrefixes = [
  '040',
  '041',
  '042',
  '043',
  '044',
  '045',
  '046',
  '047',
  '048',
  '049',
  '050',
  '+35840',
  '+35841',
  '+35842',
  '+35843',
  '+35844',
  '+35845',
  '+35846',
  '+35847',
  '+35848',
  '+35849',
  '+35850',
];

export const phoneToInternational = (phone: string, prefix = '+358') => {
  if (phone.trim().startsWith('0')) {
    return prefix + phone.trim().substring(1);
  }
  return phone;
};

export const isPhone = (value?: string): boolean => {
  if (!value) {
    return true;
  }
  const international = phoneToInternational(value);
  const putsattu = international.replace(/[\s\-\(\),]/g, '').trim();
  const regex1 = /^[\d-+ ]+$/;
  const regex2 = /^\+?[0-9]*$/;
  const regex3 = /[+][0-9]+/;
  return !!(putsattu.length >= 9 && putsattu.match(regex1) && putsattu.match(regex2) && putsattu.match(regex3));
};

export const isFinnishPhone = (value?: string) => {
  if (!value) {
    return true;
  }
  const international = phoneToInternational(value);
  const putsattu = international.replace(/[\s\-\(\),]/g, '').trim();
  return isPhone(value) && finnishPhonePrefixes.some((x) => putsattu.startsWith(x));
};
